// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__fYpeq","group":"navigation_group__7CkNw"};